import "./App.css";
import { Route, Routes, Navigate } from "react-router";
import { App } from "antd";
import { HashRouter } from "react-router-dom";
import {
  LOGIN,
  LANDING,
  AR_NO_MATCH,
  CONFIGURATION_DASHBOARD,
  CONFIGURATION_GROUPS,
  CONFIGURATION_SUBGROUPS,
  CONFIGURATION_GROUP_METER_CONFIG,
  UNAUTHORIZED_PATH,
  CONFIGURATION_GROUPS_ADD_POPUP,
  ELECTRICAL_DASHBOARD,
  STEAM_DASHBOARD,
  TEMPERATURE_DASHBOARD,
  AIR_DASHBOARD,
  WATER_DASHBOARD,
} from "./Common/Constants";
import LoginForm from "./components/CommonScreens/LoginForm";
import LandingPage from "./components/CommonScreens/LandingPage";
import ConfigurationLayout from "./components/CommonScreens/ConfigurationLayout";


import PopupUI from "./components/Elements/PopupUI";
import { GroupPopup } from "./components/CommonScreens/CreateGroup";
import MainLayout from "./Common/Footer";
import ElectricalLayout from "./components/CommonScreens/SidebarLayout";

import OrgChartData from "./components/Screens/Electrical/Charts/TreeChart/OrgChart/OrgChartData";
import CombinedChart from "./components/Screens/Electrical/Charts/EnergyChart/CombinedChart";
import LiveChart from "./components/Screens/Electrical/Charts/LiveModule/LiveTrends/LineChart/LiveChart";
import MeterStatus from "./components/Screens/Electrical/Charts/LiveModule/MeterStatus/MeterStatus";

import SteamLayout from "./components/CommonScreens/SteamLayout";
import SteamHomeTreeChart from "./components/Screens/Steam/SteamHomeTreeChart/SteamHomeTreeChart";
import SteamLiveChart from "./components/Screens/Steam/SteamHomeTreeChart/SteamLiveModule/SteamLiveTrends/SteamLineChart/SteamLiveChart";
import SteamMeterStatus from "./components/Screens/Steam/SteamHomeTreeChart/SteamLiveModule/SteamMeterStatus/SteamMeterStatus";

import TemperatureLayout from "./components/CommonScreens/TemperatureLayout";
import SteamConvertorStatus from "./components/Screens/Steam/SteamHomeTreeChart/SteamGaugeCard/SteamConvertorStatus";

import {
  AirItems,
  AirNavItems,
  ConfigurationItems,
  Configurationitems,
  ConfigurationNavItems,
  ElectricalItems,
  ElectricalNavItems,
  SteamItems,
  SteamNavItems,
  TempItems,
  TempNavItems,
  WaterItems,
  WaterNavItems,
} from "./components/Elements/NavRoutes";
import SidebarLayout from "./components/CommonScreens/SidebarLayout";
import TempTreeChart from "./components/Screens/Temperature/TemperatureModule/TempTreeChart";
import ComparativeReport from "./components/Screens/Steam/SteamHomeTreeChart/Comparative/ComparativeReport";
import RawData from "./components/Screens/Steam/SteamHomeTreeChart/RawData/RawData";
import HistoricalTrends from "./components/Screens/Steam/SteamHomeTreeChart/HistoricalTrends/HistoricalTrends";
import ConsumptionReport from "./components/Screens/Steam/SteamHomeTreeChart/ConsumptionReport/ConsumptionReport";

// import { ElectricalItems, ElectricalNavItems, TempItems, TempNavItems } from "./components/Elements/NavRoutes";
import ParameterView from "./components/Screens/Electrical/Charts/LiveModule/ParameterView/ParameterView";
// import TempPlantForm from "./components/Screens/Temperature/TemperatureModule/TempPlantForm/TempPlantForm";
import TempLiveChart from "./components/Screens/Temperature/TemperatureModule/TempLiveModule/TempLiveTrends/TempLineChart/TempLiveChart";
import TempMeterStatus from "./components/Screens/Temperature/TemperatureModule/TempLiveModule/TempLiveTrends/TempMeterStatus/TempMeterStatus";
import TempConvertorStatus from "./components/Screens/Temperature/TemperatureModule/TempLiveModule/TempLiveTrends/TempGaugeCard/TempConvertorStatus";
import TempComparativeReport from "./components/Screens/Temperature/TemperatureModule/HistoricalReports/TempComparativeReport/TempComparativeReport";
import TempConsumptionReport from "./components/Screens/Temperature/TemperatureModule/HistoricalReports/TempConsumptionReport/TempConsumptionReport";
import TempRawDataGrid from "./components/Screens/Temperature/TemperatureModule/HistoricalReports/TempRawData/TempRawDataGrid";
import TempHistoricalTrends from "./components/Screens/Temperature/TemperatureModule/HistoricalReports/TempHistoricalTrends/TempHistoricalTrends";
import AirTreeChart from "./components/Screens/Air/AirTreeChart";
// import AirPlantForm from "./components/Screens/Air/AirPlantForm/AirPlantForm";
import AirLiveChart from "./components/Screens/Air/AirLiveModule/AirLiveTrends/AirLineChart/AirLiveChart";
import AirMeterStatus from "./components/Screens/Air/AirLiveModule/AirLiveTrends/AirMeterStatus/AirMeterStatus";
import AirConvertorStatus from "./components/Screens/Air/AirLiveModule/AirLiveTrends/AirGaugeCard/AirConvertorStatus";
import AirComparativeReport from "./components/Screens/Air/HistoricalReports/AirComparativeReport/AirComparativeReport";
import AirConsumptionReport from "./components/Screens/Air/HistoricalReports/AirConsumptionReport/AirConsumptionReport";
import AirRawDataGrid from "./components/Screens/Air/HistoricalReports/AirRawData/AirRawDataGrid";
import AirHistoricalTrends from "./components/Screens/Air/HistoricalReports/AirHistoricalTrends/AirHistoricalTrends";
import WaterTreeChart from "./components/Screens/Water/WaterTreeChart";
// import WaterPlantForm from "./components/Screens/Water/WaterPlantForm/WaterPlantForm";
import WaterLiveChart from "./components/Screens/Water/WaterLiveModule/WaterLiveTrends/WaterLineChart/WaterLiveChart";
import WaterMeterStatus from "./components/Screens/Water/WaterLiveModule/WaterLiveTrends/WaterMeterStatus/WaterMeterStatus";
import WaterConvertorStatus from "./components/Screens/Water/WaterLiveModule/WaterLiveTrends/WaterGaugeCard/WaterConvertorStatus";
import WaterComparativeReport from "./components/Screens/Water/HistoricalReports/WaterComparativeReport/WaterComparativeReport";
import WaterRawDataGrid from "./components/Screens/Water/HistoricalReports/WaterRawData/WaterRawDataGrid";
import WaterConsumptionReport from "./components/Screens/Water/HistoricalReports/WaterConsumptionReport/WaterConsumptionReport";
import WaterHistoricalTrends from "./components/Screens/Water/HistoricalReports/WaterHistoricalTrends/WaterHistoricalTrends";
import PrivateRoutes from "./Store/PrivateRoute";
import ThemeToggle from "./components/Elements/ThemeToggle";
import ComparitiveReport from "./components/Screens/Electrical/Charts/HistoricalReports/ComparativeReport/ComparativeRepot";
import ConsumptionReportElectrical from "./components/Screens/Electrical/Charts/HistoricalReports/ConsumptionReport/ConsumptionReportElectrical";
import RawDataElectrical from "./components/Screens/Electrical/Charts/HistoricalReports/RawData/RawDataGrid/RawData";
import ConverterConfiguration from "./components/Screens/Configuration/Electrical/ConverterConfiguration";
import MeterConfiguration from "./components/Screens/Configuration/Electrical/DeviceConfiguration.jsx";
import UserRegistration from "./components/Screens/Configuration/Electrical/UserRegistration";
import Groups from "./components/Screens/Configuration/Electrical/GroupConfiguration/Groups";
import SubGroup from "./components/Screens/Configuration/Electrical/GroupConfiguration/SubGroup";
import GroupMeterConfig from "./components/Screens/Configuration/Electrical/GroupConfiguration/GroupMeterConfig";
import SteamGroup from "./components/Screens/Configuration/SteamGrouping/SteamGroup";
import SteamSubGroup from "./components/Screens/Configuration/SteamGrouping/SteamSubGroup";
import SteamGroupMeter from "./components/Screens/Configuration/SteamGrouping/SteamGroupMeter";
import WaterGroup from "./components/Screens/Configuration/WaterGrouping/WaterGroup";
import WaterSubGroup from "./components/Screens/Configuration/WaterGrouping/WaterSubGroup";
import WaterGroupMeter from "./components/Screens/Configuration/WaterGrouping/WaterGroupMeter";
import { useSelector } from "react-redux";
import ElectricalHistoricalTrends from "./components/Screens/Electrical/Charts/HistoricalReports/HistoricalTrends/ElectrialHistoricalTrends";
import GroupConfig from "./components/Screens/Electrical/Charts/Groups/Group-Config/GroupConfig";
import ElectricalGroup from "./components/Screens/Electrical/Charts/Groups/Group/ElectricalGroups.jsx";
import ElectricalSubGroup from "./components/Screens/Electrical/Charts/Groups/Subgroup/ElectricalSubGroup.jsx";
import GroupReport from "./components/Screens/Electrical/Charts/Groups/GroupReport/GroupReport.jsx";
import DeviceConfiguration from "./components/Screens/Configuration/Electrical/DeviceConfiguration.jsx";
import DashboardPage from "./components/dashboard/DashbardPage.jsx";
import ExcelConfiguration from "./components/Screens/Configuration/Electrical/ExcelConfiguration.jsx";


export default function Router() {

  const loggedIn = useSelector((state)=>state.user.login)
  console.log(loggedIn)
  return (
    <>
      <App>
        <HashRouter>
          <Routes>

                <Route path={LOGIN} element={<LoginForm/>}/>
                <Route path={LANDING} element={<LandingPage/>}/>

                {/* Configuration layout */}
                <Route
                  path={CONFIGURATION_DASHBOARD + "/*"} 
                  element={ <PrivateRoutes>
                    <SidebarLayout
                      NavItems={ConfigurationNavItems}
                      items={ConfigurationItems}
                      title={'Configuration'}
                      DefaultRoute={<ConverterConfiguration />}
                    />
                  </PrivateRoutes>
                }
                >

                  <Route path="Converter-config" element={<ConverterConfiguration />}>
                    <Route path="converter-add-popup" element={<ConverterConfiguration />} />

                  </Route>
                  <Route path="Device-config" element={<DeviceConfiguration />}>
                    <Route path="device-add-popup" element={<DeviceConfiguration />} />
                  </Route>
                  <Route path="Excel-config" element={<ExcelConfiguration />}>
                    <Route path="excel-add-popup" element={<ExcelConfiguration />} />
                  </Route>
                  <Route path="User-registration" element={<UserRegistration />}>
                    <Route path="user-add-popup" element={<UserRegistration />} />

                  </Route>


                  <Route path="Group-config/group" element={<Groups />}>
                    <Route path="group-add-popup" element={<Groups />} />
                    <Route path="group-update-popup" element={<Groups />} />

                  </Route>

                  <Route path="Group-config/sub-group" element={<SubGroup />}>
                    <Route path="sub-group-add-popup" element={<SubGroup />} />
                    <Route path="sub-group-update-popup" element={<SubGroup />} />

                  </Route>


                  <Route path="Group-config/group-meter" element={<GroupMeterConfig />}>
                    <Route path="group-meter-add-popup" element={<GroupMeterConfig />} />
                    <Route path="group-meter-update-popup" element={<GroupMeterConfig />} />
                  </Route>



                  {/* <Route path="Steam-grouping/group" element={<SteamGroup />}>
                    <Route path="group-add-popup" element={<SteamGroup />} />
                    <Route path="group-update-popup" element={<SteamGroup />} />
                  </Route>

                  <Route path="Steam-grouping/sub-group" element={<SteamSubGroup />}>
                    <Route path="sub-group-add-popup" element={<SteamSubGroup />} />
                    <Route path="sub-group-update-popup" element={<SteamSubGroup />} />
                  </Route> 
                  
                  <Route path="Steam-grouping/group-meter" element={<SteamGroupMeter />}>
                    <Route path="group-meter-add-popup" element={<SteamGroupMeter />} />
                    <Route path="group-meter-update-popup" element={<SteamGroupMeter />} />
                  </Route>

                  <Route path="Water-grouping/group" element={<WaterGroup />}>
                    <Route path="group-add-popup" element={<WaterGroup />} />
                    <Route path="group-update-popup" element={<WaterGroup />} />
                  </Route>

                  <Route path="Water-grouping/sub-group" element={<WaterSubGroup />}>
                    <Route path="sub-group-add-popup" element={<WaterSubGroup />} />
                    <Route path="sub-group-update-popup" element={<WaterSubGroup />} />
                  </Route> 
                  
                  <Route path="Water-grouping/group-meter" element={<WaterGroupMeter />}>
                    <Route path="group-meter-add-popup" element={< WaterGroupMeter/>} />
                    <Route path="group-meter-update-popup" element={<WaterGroupMeter />} />
                  </Route> */}

                </Route>

                {/* Electrical layout */}
                <Route
                  path={ELECTRICAL_DASHBOARD + "/*"}
                  element={
                    <PrivateRoutes>
                      <SidebarLayout
                        NavItems={ElectricalNavItems}
                        items={ElectricalItems}
                        title={'Electrical'}
                        DefaultRoute={<DashboardPage />}
                      />
                    </PrivateRoutes>
                  }
                >
                  {/* <Route path="tree-chart" element={<OrgChartData />}>
                    <Route path="tree-chart-popup" element={<OrgChartData />} />
                  </Route> */}

                  <Route path="dashboard" element={<DashboardPage/>} />
                  <Route path="live-trends" element={<LiveChart/>} />
                  <Route path="meter-status" element={<MeterStatus />}>
                    <Route path="meter-status-popup" element={<MeterStatus/>}/>
                  </Route>
                  <Route path="parameter-view" element={<ParameterView />} /> 

                  <Route path="comparative-report" element={<ComparitiveReport/>}/>
                  <Route path="raw-data" element={< RawDataElectrical />}/>
                  <Route path="historical-trends" element={<ElectricalHistoricalTrends /> } /> 
                  <Route path="consumption-report" element={<ConsumptionReportElectrical/>} />

                  <Route path="groups" element={<ElectricalGroup/>}/>
                  <Route path="sub-group" element={<ElectricalSubGroup />}/>
                  <Route path="group-config" element={<GroupConfig />}/>
                  <Route path="group-report" element={<GroupReport/>} />
                </Route>

                {/* Steam Layout */}
                <Route 
                  path={STEAM_DASHBOARD + "/*"}
                  element={<PrivateRoutes>
                    <SidebarLayout 
                      items={SteamItems}
                      NavItems={SteamNavItems}
                      DefaultRoute={<SteamLiveChart />}
                    />
                  </PrivateRoutes>
                    
                  }
                >
                  {/* <Route path="tree-chart" element={<SteamHomeTreeChart />}>
                    <Route
                      path="tree-chart-popup"
                      element={<SteamHomeTreeChart />}
                    />
                  </Route> */}
                  <Route path="steam-live-trends" element={<SteamLiveChart />} />


                  <Route path="meter-status" element={<SteamMeterStatus />} >
                    <Route path="meter-status-popup" element={<SteamMeterStatus />} />
                  </Route>


                  <Route 
                    path="steam-convertor-status"
                    element={<SteamConvertorStatus />}
                  >
                    <Route
                      path="steam-convertor-status-popup"
                      element={<SteamConvertorStatus />}
                    />

                  </Route>
                  <Route
                    path="comparative-report"
                    element={<ComparativeReport />}
                  />
                  <Route path="raw-data" element={<RawData />} />
                  <Route path="historical-trends" element={<HistoricalTrends />} />
                  <Route
                    path="consumption-report"
                    element={<ConsumptionReport />}
                  />
                </Route>

                {/* Temperature layout */}
                <Route 
                  path={TEMPERATURE_DASHBOARD + "/*"} 
                  element={<PrivateRoutes> 
                    <SidebarLayout  
                      items={TempItems} 
                      NavItems={TempNavItems} 
                      DefaultRoute={<TempLiveChart />} 
                    /> 
                  </PrivateRoutes> 
                  }
                >
                  {/* <Route path="tree-chart" element={<TempTreeChart />}>
                    <Route path="tree-chart-popup" element={<TempTreeChart />} />
                  </Route> */} 

                  <Route path="temp-live-trends" element={<TempLiveChart />} />
                  <Route path="meter-status" element={<TempMeterStatus />} >
                    <Route path="meter-status-popup" element={<TempMeterStatus />} />
                  </Route>
                  <Route
                    path="temperature-convertor-status"
                    element={<TempConvertorStatus />}
                  >
                    <Route
                      path="temperature-convertor-status-popup"
                      element={<TempConvertorStatus />}
                    />
                  </Route>

                  {/* <Route 
                    path="temp-comparative-report" 
                    element={<TempComparativeReport />} 
                  /> */}
                  <Route path="temp-raw-data" element={<TempRawDataGrid />} />
                  <Route 
                    path="temp-historical-trends" 
                    element={<TempHistoricalTrends />} 
                  />
                  {/* <Route 
                    path="temp-consumption-report"
                    element={<TempConsumptionReport />}
                  /> */}
                </Route>

                {/* Air Layout */}
                <Route
                  path={AIR_DASHBOARD + "/*"}
                  element={<PrivateRoutes>
                    <SidebarLayout
                      items={AirItems}
                      NavItems={AirNavItems}
                      DefaultRoute={<AirLiveChart />}
                    />
                  </PrivateRoutes>
                  }
                >
                  {/* <Route path="tree-chart" element={<AirTreeChart />}>
                    <Route path="tree-chart-popup" element={<AirTreeChart />} />
                  </Route> */}

                  {/* <Route path="plant-form" element={<AirPlantForm />}>
                    <Route path="plant-add-popup" element={<AirPlantForm />} />

                    <Route path="plant-update-popup" element={<AirPlantForm />} />
                  </Route> */}
                  <Route path="air-live-trends" element={<AirLiveChart />} />
                  <Route path="meter-status" element={<AirMeterStatus />} >
                    <Route path="meter-status-popup" element={<AirMeterStatus />} />
                  </Route>
                  <Route
                    path="air-convertor-status"
                    element={<AirConvertorStatus />}
                  >
                    <Route
                      path="air-convertor-status-popup"
                      element={<AirConvertorStatus />}
                    />
                  </Route>

                  <Route
                    path="air-comparative-report"
                    element={<AirComparativeReport />}
                  />
                  <Route path="air-raw-data" element={<AirRawDataGrid />} />
                  <Route
                    path="air-historical-trends"
                    element={<AirHistoricalTrends />}
                  />
                  <Route
                    path="air-consumption-report"
                    element={<AirConsumptionReport />}
                  />
                </Route>

                {/* water layout */}
                <Route
                  path={WATER_DASHBOARD + "/*"}
                  element={
                    <PrivateRoutes>
                      <SidebarLayout
                        items={WaterItems}
                        NavItems={WaterNavItems}
                        DefaultRoute={<WaterLiveChart />}
                      />
                    </PrivateRoutes>
                  }
                >
                  {/* <Route path="tree-chart" element={<WaterTreeChart />}>
                    <Route path="tree-chart-popup" element={< WaterTreeChart/>} />
                  </Route> */}


                  <Route path="water-live-trends" element={<WaterLiveChart />} />
                  <Route path="meter-status" element={<WaterMeterStatus />} >
                    <Route path="meter-status-popup" element={<WaterMeterStatus />} />
                  </Route>
                  <Route
                    path="water-convertor-status"
                    element={<WaterConvertorStatus />}
                  >
                    <Route
                      path="water-convertor-status-popup"
                      element={<WaterConvertorStatus />}
                    />
                  </Route>

                  <Route
                    path="water-comparative-report"
                    element={<WaterComparativeReport />}
                  />
                  <Route path="water-raw-data" element={<WaterRawDataGrid />} />
                  <Route
                    path="water-historical-trends"
                    element={<WaterHistoricalTrends />}
                  />
                  <Route
                    path="water-consumption-report"
                    element={<WaterConsumptionReport />}
                  />
                </Route>
                
                <Route path={AR_NO_MATCH} element={<Navigate to={LOGIN} />} />
                <Route path={UNAUTHORIZED_PATH} element={<Navigate to={LOGIN} />} />

          </Routes>
        </HashRouter>
      </App>
    </>
  );
}
